import React from 'react';

import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';

import QuickStartGuideDesktop from './components/QuickStartGuideDesktop';
import QuickStartGuideMobile from './components/QuickStartGuideMobile';

const QuickStartGuidePopup = ({onClose, deviceType}) => {
    const isMobile = useIsMobileLayout();

    return isMobile ? (
        <QuickStartGuideMobile onClose={onClose} deviceType={deviceType} />
    ) : (
        <QuickStartGuideDesktop onClose={onClose} deviceType={deviceType} />
    );
};

export default QuickStartGuidePopup;
